<template>
  <div class="editor-tabs">

    <!--
    <b-tooltip label = "Play/Stop (Control + R)" position="is-right">
    </b-tooltip>
    -->

    <div>
      <button id = "play" v-if = "!editorConfig.isSketchRunning" v-on:click = "run(true)" class = "btn btn-icon"><span class = "material-icons md-24">play_arrow</span></button>
      <button id = "stop" v-else v-on:click = "run(false)" class = "btn btn-icon"><span class = "material-icons md-24">stop</span></button>
    </div>

    <div id = "tabs">
      <div  class = "tab"
            v-for = "(file, i) in codefiles"
            :key = "file.name"
            v-on:click = "selectTab(i, file.name)"
            v-bind:class = "{ activeTab: i === editorConfig.tabSelected }">

        <span class = "filename">{{file.name}}</span>
        <b-dropdown v-if = "file.name !== 'main'">
          <a class="" slot="trigger"><b-icon icon="menu-down"></b-icon></a>
          <b-dropdown-item v-on:click = "renameCodeFile">Renombrar</b-dropdown-item>
          <b-dropdown-item v-on:click = "deleteCodeFile">Borrar</b-dropdown-item>
        </b-dropdown>
      </div>

      <b-tooltip v-if = "isWritable" label = "Crear una pestaña nueva" >
        <button class = "btn btn-icon" v-on:click = "showCreateFile"><span class="icon"> <i class="mdi mdi-plus-box"></i></span></button>
      </b-tooltip>
    </div>

    <b-tooltip label = "Gestor de imágenes">
      <button v-if="isWritable && isAuthenticated" class = "btn btn-icon" v-on:click = "isShowingUploadFile=true"> <span class = "material-icons md-24">cloud_upload</span></button>
    </b-tooltip>

    <b-tooltip label = "Guardar">
      <button v-if="isWritable" class = "btn btn-icon" v-on:click = "saveProject"><span class = "material-icons md-24">save</span></button>
    </b-tooltip>

    <div class = "clone-area">
      <router-link  v-if="isCloneable && !isExample" class = "btn btn-bg-colored btn-no-margin btn-right-icon clone" :to="{ name: 'Editor.clone', params: { id: project.id } }" target="_blank"><span>Clonar</span><span class = "material-icons md-24">call_split</span></router-link>
      <button v-if="isCloneable && isExample  " class = "btn btn-bg-colored btn btn-bg-colored btn-no-margin btn-right-icon clone" v-on:click = "cloneProject"><span>Clonar</span><span class = "material-icons md-24">call_split</span></button>
    </div>

    <div v-if = "isUserAdmin" class = "admin">
      <!--
      <b-tooltip label = "Reajustar Tamaño">
        <button class = "btn btn-icon" v-on:click = "changeSize"><span class = "material-icons md-24">save</span></button>
      </b-tooltip>
      -->

      <b-tooltip label = "Guardar">
        <button class = "btn btn-icon" v-on:click = "saveProject"><span class = "material-icons md-24">save</span></button>
      </b-tooltip>
    </div>

    <b-modal :active.sync="isShowingCreateFile">
      <editor-new-file></editor-new-file>
    </b-modal>
    <b-modal :active.sync="isShowingRenameFile">
      <editor-rename-file></editor-rename-file>
    </b-modal>
    <b-modal :active.sync="isShowingUploadFile">
      <upload-file></upload-file>
    </b-modal>
  </div>
</template>

<script>
// import _ from 'lodash'
import EditorNewFile from './EditorNewFile'
import EditorRenameFile from './EditorRenameFile'
import uploadFile from '../UI/uploadFile'
export default {
  name: 'EditorTabs',
  components: {
    EditorNewFile,
    EditorRenameFile,
    uploadFile
  },
  props: {
    project: Object
  },
  data () {
    return {
      isShowingCreateFile: false,
      isShowingRenameFile: false,
      isShowingUploadFile: false
    }
  },
  computed: {
    editorConfig: function () {
      return this.$store.state.editorConfig
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    codefiles () {
      // I guess this ordering can be done better...
      let codefiles = this.project.codefiles

      return codefiles
    },
    isWritable () {
      return this.$store.getters.getIsProjectWritable
    },
    isUserAdmin () {
      return this.$store.getters.getIsUserAdmin
    },
    isCloneable () {
      return this.$store.getters.getIsProjectCloneable
    },
    isExample () {
      return this.$store.getters.getIsProjectExample
    }
  },
  methods: {
    run: function (val) {
      // console.log('run')
      this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': val })
    },
    selectTab: function (i, name) {
      console.log('selectingTab' + i + ' ' + name)
      this.$store.commit('setEditorConfigProperty', {'tabSelected': i})
    },
    saveProject: function () {
      this.$store.dispatch('handleSaveProject')
    },
    showCreateFile: function () {
      this.isShowingCreateFile = true
    },
    deleteCodeFile: function () {
      let codefile = this.codefiles[this.editorConfig.tabSelected]
      console.log(codefile)
      this.$store.dispatch('deleteCodeFile', codefile)
    },
    renameCodeFile: function () {
      this.isShowingRenameFile = true
    },
    changeSize: function () {
    },
    cloneProject: function () {
      console.log('clone', this.project.id)
      // this.$store.dispatch('cloneProject', this.project.id)
      this.$store.dispatch('cloneExample')
    }
  },
  mounted () {
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.editor-tabs {
  // background: @surfaceColor;
  // border-bottom: 3px solid #d7d979;
  display: flex;
  flex-grow: unset;
  align-items: stretch;
  // font-family: Roboto Mono;
  user-select: none;
}

#tabs {
  display: flex;
  flex: 2;
}

.tab {
  display: inline-block;
  color: black;
  padding: 10px 12px;
  text-align: center;
  // max-width: 80px;
  min-width: 50px;
  cursor: pointer;

  span:hover {
    border-color: blue;
    // background: lighten(@accentColor, 10%);
    color: black;
  }

  span:active {
    // background: darken(@accentColor, 10%);
  }

  .dropdown {
    display: none;
  }

  span {
    color: #0008;
  }
}

.activeTab {
  span.filename {
    border-bottom: 5px solid @accentColor;
    color: black;
  }

  .dropdown {
    display: inline-block;
  }
}

#play {
  color: @accentColor;
  font-size: 1.5em;
}

#stop {
  color: @redcolor;
  font-size: 1.5em;
}

.clone {
  background: @accentColorSecondary;
  color: @secondaryTextColor;
  // border-radius: 120px;
  padding: 11px 15px;
}

.admin {
  background: @adminColor;
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorTabs.vue